/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// @mui material components
import Card from "@mui/material/Card";

// Vision UI Dashboard React components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import VuiBox from "components/VuiBox";
import VuiInput from "components/VuiInput";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";

// Vision UI Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import React, { useEffect, useState, useCallback } from "react"

import { useHistory, useLocation } from 'react-router-dom';
import { getUser } from 'discordAPI'
import { getAPIToken, getGuilds, updateGuild } from 'GaiaAPI'


function GuildsEdit() {
    const history = useHistory();
    const location = useLocation();
    const [guildName, setGuildName] = useState([]);
    const [guilds, setGuilds] = useState([]);

    const [user, setUser] = useState([]);
    const [saveDisabled, setSaveDisabled] = useState(true);
    const [saveMessage, setSaveMessage] = useState([]);
    const [saveMessageColor, setSaveMessageColor] = useState([]);

    const [guildColour, setGuildColour] = useState([]);

    const [seScore, setseScore] = useState([]);
    const [sePos, setsePos] = useState([]);
    const [acePos, setAcePos] = useState([]);


    const updateSePos = (newVal) => { setsePos(newVal); setSaveDisabled(false); };
    const updateAcePos = (newVal) => { setAcePos(newVal); setSaveDisabled(false); };

    const [menuGuild, setMenuGuild] = useState(null);
    const openMenuGuild = ({ currentTarget }) => setMenuGuild(currentTarget);
    const closeMenuGuild = () => setMenuGuild(null);

    const renderMenuGuild = (
        <Menu
            id="simple-menu"
            anchorEl={menuGuild}
            anchorOrigin={{
                vertical: "top",
                horizontal: "left",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            open={Boolean(menuGuild)}
            onClose={closeMenuGuild}
        >
            {
                guilds.map((guild) => (
                    <MenuItem onClick={() => selectGuild(guild.name)}>{guild.name}</MenuItem>
                ))
            }
        </Menu>
    );

    const selectGuild = (guild) => {
        setGuildDetails(guilds, guild);
        setMenuGuild(null)
    };

    function setGuildDetails(guilds, guildname) {
        setSaveDisabled(true);
        setGuildName(guildname);
        let myGuild = guilds.find(g => g.name === guildname);
        if (myGuild && myGuild.colour) {
            setGuildColour('#' + myGuild.colour);
        }

        setseScore(myGuild.seScore);
        if (myGuild.sePosition)
            setsePos(myGuild.sePosition);
        if (myGuild.lastAce)
            setAcePos(myGuild.lastAce);
    }



    const handleSaveClick = () => {
        let updaterDiscord = user.username + ' (' + user.name + ') - Web';

        getAPIToken()
            .then((token) => {                    
                try {
                    updateGuild(token, guildName, sePos, acePos, updaterDiscord)
                        .then(() => {
                            setSaveMessage('Save Complete');
                            setSaveMessageColor("success");
                            setSaveDisabled(true);
                            localStorage.removeItem("guildsUpdateDate");
                        },
                        (err) => {
                            setSaveMessage(err.toString());
                            setSaveMessageColor("error");
                        });
                } catch (err) {
                    setSaveMessage(err.toString());
                    setSaveMessageColor("error");
                }
            },
            (err) => {
                alert(err);
                setSaveMessage(err.toString());
                setSaveMessageColor("error");
            });
    };

    const getDetails = useCallback(async () => {
        let guildname = location.state.guildname;
        setGuildName(guildname)

        getUser()
            .then((result) => {
                setUser(result);
                getAPIToken()
                    .then((token) => {
                        getGuilds(token)
                            .then((guildsResult) => {
                                setGuilds(guildsResult);
                                setGuildDetails(guildsResult, guildname);
                            },
                            (error) => {
                                alert(error);
                                });
                    },
                    (error) => {
                        alert(error);
                    });
            },
            (error) => {
                history.push('/authentication/sign-in');
            });
    }, []);


    useEffect(() => {
        getDetails();
    }, [getDetails]);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <VuiBox py={3}>
                <VuiBox mb={3}>
                    <Card style={{ backgroundColor: guildColour }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6} xl={12}>
                                <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
                                    Guild
                                </VuiTypography>
                                <VuiBox display="flex" justifyContent="space-between" alignItems="center" mb="0px">
                                    <VuiInput
                                        type="text"
                                        value={guildName}
                                        bgColor={guildColour}
                                        disabled="true"
                                    />
                                    <Icon sx={{ cursor: "pointer", fontWeight: "bold", color: "#ffffff" }} fontSize="small" onClick={openMenuGuild}>
                                        arrow_drop_down
                                    </Icon>
                                    {renderMenuGuild}

                                </VuiBox>
                            </Grid>
                            <Grid item xs={12} md={6} xl={6}>
                                <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
                                    Star Expedition Position
                                </VuiTypography>
                                <VuiInput
                                    onChange={e => updateSePos(e.target.value)}
                                    type="number"
                                    value={sePos}
                                />
                                <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
                                    Score of {seScore}
                                </VuiTypography>
                            </Grid>
                            <Grid item xs={12} md={6} xl={6}>
                                <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
                                    Ace Position
                                </VuiTypography>
                                <VuiInput
                                    onChange={e => updateAcePos(e.target.value)}
                                    type="number"
                                    value={acePos}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} xl={12}>
                                <Card>
                                    <VuiButton
                                        disabled={saveDisabled}
                                        onClick={handleSaveClick}
                                        color="info"
                                        sx={{ textAlign: "center", fontWeight: "500 !important" }} >
                                        Save Changes
                                    </VuiButton>
                                    <VuiTypography align="center" component="label" variant="button" color={saveMessageColor} fontWeight="medium">
                                        {saveMessage}
                                    </VuiTypography>
                                </Card>
                            </Grid>
                        </Grid>
                    </Card>
                </VuiBox>
            </VuiBox>
            <Footer />
        </DashboardLayout>
    );
}

export default GuildsEdit;
